import { GALLERY_v4_CONSTS } from '@wix/photography-client-lib';
var VideoSeoHelper = /** @class */ (function () {
    function VideoSeoHelper() {
    }
    VideoSeoHelper.getEmbedUrl = function (url) {
        var youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/(watch\?v=|embed\/|v\/)?([\w-]+).*$/;
        var vimeoRegex = /^(https?:\/\/)?(www\.)?vimeo\.com\/(\d+).*$/;
        var youtubeMatch = url.match(youtubeRegex);
        var vimeoMatch = url.match(vimeoRegex);
        if (youtubeMatch && youtubeMatch[5]) {
            var videoId = youtubeMatch[5];
            return "https://www.youtube.com/embed/".concat(videoId);
        }
        else if (vimeoMatch && vimeoMatch[3]) {
            var videoId = vimeoMatch[3];
            return "https://player.vimeo.com/video/".concat(videoId);
        }
        else {
            return '';
        }
    };
    VideoSeoHelper.getFormattedDuration = function (milliseconds) {
        //convert milliseconds duration to ISO 8601 duration format (e.g., PT5M01S)
        var duration = "PT".concat(Math.floor(milliseconds / 60000), "M").concat(((milliseconds % 60000) / 1000).toFixed(0).padStart(2, '0'), "S");
        return duration;
    };
    VideoSeoHelper.getSeoProperties = function (galleryItem) {
        var _a, _b, _c, _d;
        var seoProperties = {
            thumbnailUrl: {
                url: galleryItem.createUrl(GALLERY_v4_CONSTS.urlSizes.RESIZED, GALLERY_v4_CONSTS.urlTypes.HIGH_RES),
                width: 250,
                height: 250,
            },
            contentUrl: (galleryItem === null || galleryItem === void 0 ? void 0 : galleryItem.type) === 'video' && ((_c = (_b = (_a = galleryItem.metaData) === null || _a === void 0 ? void 0 : _a.qualities) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.url) || '',
            uploadDate: (_d = galleryItem === null || galleryItem === void 0 ? void 0 : galleryItem.dto) === null || _d === void 0 ? void 0 : _d.createdDate,
            duration: this.getFormattedDuration(galleryItem.metaData.duration) || '',
            embedUrl: this.getEmbedUrl(galleryItem.metaData.videoUrl) || '',
        };
        return seoProperties;
    };
    return VideoSeoHelper;
}());
export default VideoSeoHelper;
//# sourceMappingURL=videoSeoHelper.js.map